import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { StandardResponse } from 'src/app/models/common.model';
import { Chapter, Course, Lesson } from 'src/app/models/course.model';
import { CourseService } from 'src/app/services/course.service';

@Component({
  selector: 'app-course-detail',
  templateUrl: './course-detail.component.html',
  styleUrls: ['./course-detail.component.scss']
})
export class CourseDetailComponent {
  constructor(private route: ActivatedRoute, private courseService: CourseService, private fb: FormBuilder, private router: Router) { }

  courseId!: string
  course: Course = {title: '', description: '', image: '', chapters: [], price:0, id: ''}
  chapterForm!: FormGroup

  ngOnInit() {
    this.courseId = this.route.snapshot.params['id'];

    this.courseService.getCourse(this.courseId).subscribe((course: StandardResponse<Course>) => {
      this.course = course.results[0]
    })

    //build the form
    this.chapterForm = this.fb.group({
      order: ['', Validators.required],
      title: ['', [Validators.required, Validators.min(12)]],
      description: ['', Validators.required]
    })
  }

  createChapter() {
    //create the chapter object
    if (this.chapterForm.valid) {
      const chapter: Chapter = {
        order: this.chapterForm.get('order')?.value,
        title: this.chapterForm.get('title')?.value,
        description: this.chapterForm.get('description')?.value
      }
      this.courseService.createChapter(this.courseId, chapter).subscribe(data => {
        console.log(data)
      })
    } else {
      console.log("form is invalid.")
    }
  }

  get form() {
    return this.chapterForm
  }

  navigate(chapter: Chapter) {
    this.router.navigate(['/home/admin/course/chapter/edit/' + chapter.id], { state: { course: this.course, id: chapter.id } })
  }

  navigateToLesson(lesson: Lesson) {
    this.router.navigate(['/home/admin/course/chapter/lesson/edit/' + lesson.id], {state: {lesson}})
  }
}
